var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uc-Page"},[_c('el-pagination',{attrs:{"hide-on-single-page":"","current-page":_vm.form.pageNumber,"page-sizes":[10, 20, 30, 40],"page-size":_vm.form.pageSize,"background":"","layout":"  prev, pager, next","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }